export default {
  title: {
    id: 'bo_agent_care_folder_details_panel_protection_plan_title',
    defaultMessage: 'Protection plan',
  },
  description: {
    id: 'bo_agent_care_folder_details_panel_protection_description',
    defaultMessage: `{count, plural,
        =0 {None}
        one {# protection plan}
        other {# protection plans}
      }`,
  },
  protectionPlanSubscribedUntil: {
    id: 'bo_agent_care_folder_details_panel_protection_plan_subscribed_status',
    defaultMessage: 'Subscribed until {endDate, date}',
  },
  protectionPlanNeedsPaymentBy: {
    id: 'bo_agent_care_folder_details_panel_protection_plan_payment_needed_status',
    defaultMessage: 'Payment needed by {date, date}',
  },
  protectionPlanAwaitingConfirmation: {
    id: 'bo_agent_care_folder_details_panel_protection_plan_awaiting_confirmation_status',
    defaultMessage: 'Awaiting confirmation',
  },
  protectionPlanTerminatedWithDates: {
    id: 'bo_agent_care_folder_details_panel_protection_plan_terminated_status',
    defaultMessage: 'Terminated on {date, date}',
  },
  noInsurancesText: {
    id: 'bo_agent_care_folder_details_panel_any_insurance_text',
    defaultMessage: 'This order has no added protection plans',
  },
  chillpack: {
    id: 'sav_platform_chillpack_new',
    defaultMessage: `Breakage and theft insurance {duration, plural,
      one {# month}
      other {# months}
    } until {date, date}`,
  },
  trustpack: {
    id: 'sav_platform_trustpack_new',
    defaultMessage: `Warranty extension {duration, plural,
      one {# month}
      other {# months}
    } months until {date, date}`,
  },
  chillpackTitle: {
    id: 'bo_agent_care_folder_details_panel_insurance_chillpack_title',
    defaultMessage: 'Breakage and theft insurance (Chillpack)',
  },
  trustpackTitle: {
    id: 'bo_agent_care_folder_details_panel_insurance_trustpack_title',
    defaultMessage: 'Warranty extension (Trustpack)',
  },
  coverageAndPartnerName: {
    id: 'bo_agent_care_folder_details_panel_insurance_accordion_name_by_partner',
    defaultMessage: '{coverageName} by {partnerName}',
  },
  policyDatesNotAvailable: {
    id: 'bo_agent_care_folder_details_panel_insurance_accordion_dates_available_after_confirmation',
    defaultMessage: 'Start and end dates available after confirmation',
  },
  policyStartAndEndDate: {
    id: 'bo_agent_care_folder_details_panel_insurance_accordion_start_and_end_dates',
    defaultMessage: 'From {startDate, date} to {endDate, date}',
  },
}
